import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Filter, SearchService } from '@docpath/linces-angular-components';
import { DpSection, HeaderAction, SearchBasicInfo, SearchMode, SearchOptionType, SearchRowInfo } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/constants/constants';

import { Alias } from '../../../alias/models/alias';
import { AlertRule } from '../../models/alert-rule';
import { AlertRulesService } from '../../services/alert-rules.service';
import { AlertRulesTableService } from '../table/alert-rules-table.service';
import { AlertRulesHeaderService } from './alert-rules-header.service';

@Component({
    selector: 'app-alert-rules-header',
    templateUrl: './alert-rules-header.component.html'
})
export class AlertRulesHeaderComponent implements OnChanges, OnInit, OnDestroy {

    @Input() alertRules: AlertRule[] = [];
    @Output() filtersChanged = new EventEmitter<Filter[]>();

    section = new DpSection({ name: 'alert-rules', rows: [], header: 'alert-rules-config.header.title', tooltip: 'alert-rules-config.header.title-tooltip' });

    rightActions: HeaderAction[] = [];
    leftActions: HeaderAction[] = [];

    alias: Alias[] = [];

    showSearch = false;

    searchAvailableOptions: SearchRowInfo[] = [
        new SearchRowInfo(true, Constants.CONF_ALERT_RULES_RULE_NAME, undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true),
        new SearchRowInfo(false, Constants.CONF_ALERT_RULES_RULE_DESCRIPTION, undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true),
        new SearchRowInfo(false, Constants.CONF_ALERT_RULES_PRIORITY, undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true)
    ];
    private filters: Filter[] = [];
    private alertRulesChangedSubscription?: Subscription;

    constructor(
        private readonly alertRulesHeaderService: AlertRulesHeaderService,
        private readonly alertRuleService: AlertRulesService,
        private readonly alertRulesTableService: AlertRulesTableService,
        private readonly searchService: SearchService
    ) {
        this.rightActions = this.alertRulesHeaderService.getRightActions(this.alias);
        const searchAction = this.alertRulesHeaderService.getSearchAction(this.rightActions);

        searchAction.action = () => {
            this.showSearch = !this.showSearch;
        };
    }

    ngOnInit(): void {

        if (!this.alertRulesChangedSubscription) {
            this.alertRulesChangedSubscription = this.alertRuleService.alertRuleChanged.subscribe(() => {
                this.leftActions = [];
            });
        }
        this.alertRulesHeaderService.aliasOptionsLoaded.subscribe(result => {
            this.alias = result;
            this.rightActions = this.alertRulesHeaderService.getRightActions(result);
            const searchAction = this.alertRulesHeaderService.getSearchAction(this.rightActions);

            searchAction.action = () => {
                this.showSearch = !this.showSearch;
            };
        });

        this.alertRulesHeaderService.loadAliasOptions();
    }

    ngOnDestroy(): void {

        if (this.alertRulesChangedSubscription) {
            this.alertRulesChangedSubscription.unsubscribe();
        }

    }

    ngOnChanges(changes: SimpleChanges): void {

        // eslint-disable-next-line dot-notation
        if (changes['alertRules']) {
            this.leftActions = this.alertRulesHeaderService.getLeftActions(this.alertRules, this.alias);
        }

    }

    isSearchVisible(): boolean {
        return this.showSearch;
    }

    clearSearch(): void {

        this.filters = [];
        this.filtersChanged.emit(this.filters);
        this.alertRulesTableService.loadAlertRules(this.filters, 1);
        this.leftActions = [];

    }

    sendSearch(currentFilters: Array<SearchBasicInfo>): void {

        this.filters = this.searchService.toFilters(currentFilters);
        this.filtersChanged.emit(this.filters);
        this.alertRulesTableService.loadAlertRules(this.filters, 1);
        this.leftActions = [];

    }

    hideSearch(): void {
        this.showSearch = false;
    }

}